import { FLWinningPerson } from './fl-winning.model';

export class ColumnConfigItem {
    id: string;
    index?: number;
    bindToId?: any;
    header?: string = '';
    width?: string;
    display?: boolean = true;
    styles?: any;
    cellstyles?: any;
    colstyle?: any;
    class?: string | string[];
    classes?: string | string[];
    icon?: Icon[];
    bindObservableToMetricId?: number;
    active?: boolean = true;
    displayByDefault?: boolean = false;
    headerContentClass?: String;
    elastic?: boolean = false;
    colclass?: string;

    actionSideEffects?: {
        [key: string]: Function;
    };

    cacheStyleProps?: {
        [key: string]: any;
    };

    left?: HeaderExtraContent;
    right?: HeaderExtraContent;

    compactView?: boolean = false;

    templateName?: string;

    constructor(init?: Partial<ColumnConfigItem>, id?: string) {
        Object.assign(this, init);
        this.id = id;
    }

    serialize(): ColumnConfigItemJson {
        return {
            id: this.id,
            styles: this.styles !== undefined ? this.styles : {},
            colstyle: this.colstyle !== undefined ? this.colstyle : {},
            active: this.active ?? false ? this.active : false,
            cacheStyleProps:
                this.cacheStyleProps != null ? this.cacheStyleProps : {},
            compactView: this.compactView ?? false ? this.compactView : false,
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
            icon: this.icon != null && this.icon.map((e) => e.serialize()),
        };
    }

    deserialize(value: ColumnConfigItemJson): void {
        Object.entries(value).forEach(([key, val]) => {
            if (key === 'icon') {
                this[key] = val.map((e) => {
                    const i = this.icon.find((c) => c.id === e.id);
                    i.deserialize(e);
                    return i;
                });
            } else {
                this[key] = val;
            }
        });
    }
}
export class Icon {
    id: string;
    iconName?: string;
    class?: string | string[];
    state?: boolean;
    defaultclass?: string | string[];
    counter?: number;
    action?: string;
    actionParams?: any;
    prop?: string;
    defaultState?: number;
    title?: string | string[];
    actionSideEffect?: Function;

    constructor(init?: Partial<Icon>, id?: string) {
        Object.assign(this, init);
        this.id = id;
    }

    toggle(): boolean {
        if (this.state !== undefined) {
            this.state = !this.state;
            if (this.class !== '' && this.counter !== this.class.length - 1) {
                this.counter++;
            } else this.counter = 0;

            return this.state;
        }
        return null;
    }

    serialize(): IconJson {
        return {
            id: this.id,
            state: this.state,
            counter: this.counter,
        };
    }

    deserialize(value: IconJson): void {
        Object.entries(value).forEach(([key, val]) => {
            this[key] = val;
        });
    }
}
export interface HeaderExtraContent {
    class?: string;
    content?: string;
}

export function mapper(data: FLWinningPerson): FLWinningPerson {
    if (data === null) {
        data = new FLWinningPerson();
        data.hasData = false;
    } else data.hasData = true;
    return data;
}

interface ColumnConfigItemJson {
    id: string;
    styles?: any;
    colstyle?: any;
    icon?: IconJson[];
    active?: boolean;
    cacheStyleProps?: {
        [key: string]: any;
    };
    compactView?: boolean;
}
interface IconJson {
    id: string;
    state?: boolean;
    counter?: number;
}

export interface PersonOfInterest {
    lastName?: string;
    firstName?: string;
    isAvailable?: boolean;
    value?: string;
    label?: string;
    userId?: number;
    favorite?: boolean;
}
export enum TrendTypeByStyle {
    UNKNOWN,
    UP = '#4B8A08',
    DOWN = '#DF0101',
    NEUTRAL = '#FF9100',
}
